import logo from "assets/images/brands/brand-main-sm.png";
import smLogo from "assets/images/brands/brand-main-sm.png";

export const clientName = "Markets Act";
export const developedBy = "Markets Act";

export const imagesUrl = process.env.REACT_APP_API_IMAGES_URL;
export const cpUrl = process.env.REACT_APP_CP_URL;
export const apiUrl = process.env.REACT_APP_API_URL;
export const companyName =  "Markets Act";
export const sidebarLogo = smLogo;
export const mainLogo = logo;
export const lightLogo = logo;
